























































import { Vue, Prop, Component, Emit } from 'vue-property-decorator';
import TreeMenu from '@/components/molecules/TreeMenu.vue';
import { i18n } from '@/plugins/i18n/i18n';
import {
  ClickProductUrlEvent,
  MenuListItem,
  UpdateFavoriteEvent,
  Product,
} from '@/types/type';

@Component({
  components: {
    TreeMenu,
  },
})
export default class SiteMapMenuListPanel extends Vue {
  @Prop()
  private menu!: MenuListItem;

  private getTabName(product: Product): string {
    return i18n.tc(`productMainMenu.${product.toString()}`);
  }

  private getFirstHalfMenus(productIndex: number): MenuListItem[] {
    const productMenus = this.getProductRootChildren(productIndex);
    return productMenus.slice(0, this.findSplitPointIndex(productMenus) + 1);
  }

  private getSecondHalfMenus(productIndex: number): MenuListItem[] {
    const productMenus = this.getProductRootChildren(productIndex);
    return productMenus.slice(this.findSplitPointIndex(productMenus) + 1);
  }

  private getProductRootChildren(productIndex: number): MenuListItem[] {
    if (this.menu.children) {
      const productMenu = this.menu.children[productIndex];
      if (productMenu.children) {
        return productMenu.children;
      }
    }
    return [];
  }

  /**
   * Return the index bisected considering these child elements
   */
  private findSplitPointIndex(items: MenuListItem[]): number {
    const childLengths: number[] = items.map(item =>
      item.children ? item.children.length : 0
    );
    const half = childLengths.reduce((p, c) => p + c) / 2;
    let current = 0;
    for (let index = 0; index < childLengths.length; index++) {
      current += childLengths[index];
      if (current > half) {
        // When half of the total is exceeded,
        // return an index that is closer to half the value compared to the previous one
        const previousCount = half - (current - childLengths[index - 1]);
        const currentCount = current - half;
        return previousCount < currentCount ? index - 1 : index;
      }
    }
    return 0;
  }

  @Emit('update-favorite')
  private updateFavorite(event: UpdateFavoriteEvent): UpdateFavoriteEvent {
    return event;
  }

  @Emit('click-url')
  private clickUrl(event: ClickProductUrlEvent): ClickProductUrlEvent {
    return event;
  }
}
